export default __webpack_public_path__ + "static/right-bg-8bdb28e13b23deaadb7ad4eb41f66f63.png";